import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Class } from '../../types';

interface ClassState {
  classes: Class[];
  selectedClass: Class | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ClassState = {
  classes: [],
  selectedClass: null,
  isLoading: false,
  error: null,
};

const classSlice = createSlice({
  name: 'classes',
  initialState,
  reducers: {
    setClasses: (state, action: PayloadAction<Class[]>) => {
      state.classes = action.payload;
    },
    setSelectedClass: (state, action: PayloadAction<Class | null>) => {
      state.selectedClass = action.payload;
    },
    addClass: (state, action: PayloadAction<Class>) => {
      state.classes.push(action.payload);
    },
    updateClass: (state, action: PayloadAction<Class>) => {
      const index = state.classes.findIndex(cls => cls.id === action.payload.id);
      if (index !== -1) {
        state.classes[index] = action.payload;
      }
    },
    removeClass: (state, action: PayloadAction<string>) => {
      state.classes = state.classes.filter(cls => cls.id !== action.payload);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setClasses,
  setSelectedClass,
  addClass,
  updateClass,
  removeClass,
  setLoading,
  setError,
} = classSlice.actions;

export default classSlice.reducer; 